<template>
  <section id="experience-section" class="experience-section container mx-auto flex flex-col items-center gap-10 sm:gap-16 pt-24">
    <!-- Title Section -->
    <div class="flex flex-col items-center gap-6 max-w-[887px]">
      <h1 class="text-center font-normal text-bw-black">
<!--        <span class="responsive-title-2">Since 1987, a world Over 35 years</span><br />-->
        <span class="responsive-title-2">{{ t('aboutExperience.titlefirst') }}</span>
       
      </h1>

      <!-- Subtitle -->
      <p class=" responsive-body-large font-normal mix-blend-multiply text-center ">
        {{ t('aboutExperience.subtitle') }}
      </p>
    </div>

    <!-- Content Section with Image and Text -->
    <div class="flex flex-col md:flex-row items-center md:justify-center md:gap-20 gap-8 max-w-[887px] mx-auto">
      <!-- Image Section -->
      <div class="max-w-[377px] max-h-[446px] rounded-8xl overflow-hidden shadow-lg flex-none">
        <img src="@/assets/about/group.png" alt="Cosmos Yachting Group" class="w-full h-full object-cover" />
      </div>

      <!-- Text Section -->
      <div class="md:text-left text-bw-black space-y-4 max-w-[433px] flex items-center justify-center">
        <div>
          <p class="responsive-body-medium">
            {{ t('aboutExperience.paragraph1') }}
          </p>
          <p class="responsive-body-medium mt-4">
            {{ t('aboutExperience.paragraph2') }}
          </p>
        </div>
        
      </div>
      
    </div>


    <!-- Bottom Paragraph -->
    <div class=" flex flex-col items-center gap-10 sm:gap-16 max-w-[430px] md:max-w-[887px] md:mx-auto"> 
      <p class="responsive-body-medium max-w-[659px] ">
        {{ t('aboutExperience.bottomparagraph1') }}
        <br /><br />
        {{ t('aboutExperience.bottomparagraph2') }}
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { usePageSEO } from '@/composables/usePageSEO'

const { t } = useI18n();
usePageSEO('about')
// export default {
//   name: "ExperienceSection",
// };
</script>
